<h2 mat-dialog-title>Add User to Dataservice</h2>
@if (!isLoading) {
    <div class="d-flex justify-content-center aligh-items-center">
        <section class="user-info" aria-label="Selected user info">
            <header class="user-header">
                <div class="avatar" aria-hidden="true">
                    {{ (data.name || data.email || 'U').charAt(0) | uppercase }}
                </div>
                <div class="meta">
                    <div class="name text-color-primary">{{ data.name }}</div>
                    <div class="email d-flex justify-content-center align-items-start">
                        <mat-icon inline class="icon-16 text-color-primary">mail</mat-icon>
                        <span class="email-text text-color-primary">{{ data.email }}</span>
                    </div>
                </div>
            </header>
        </section>
    </div>

    @if(!isDataserviceLoading){
        <div class="table-wrapper">
            <table mat-table [dataSource]="dataservicesDataSource" class="mat-elevation-z2">

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>ID</th>
                    <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>

                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef>Type</th>
                    <td mat-cell *matCellDef="let element">{{ element.type }}</td>
                </ng-container>
        
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button color="warn" aria-label="Delete company" (click)="onDeleteDataservice(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="companyDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: companyDisplayedColumns"></tr>
            </table>
        </div>
    }@else{
        <div class="d-flex justify-content-center align-items-center">
            <mat-progress-spinner class="bright-spinner" mode="indeterminate"></mat-progress-spinner>
        </div>
    }

    <form [formGroup]="addUserDataServiceForm" novalidate (keydown.enter)="$event.preventDefault()">
        <mat-dialog-content class="mat-typography">
            <div class="form-grid">
                <search-company class="full" appearance="fill" [searchCompanyForm]="addUserDataServiceForm" [companyCallback]="onSelectCompany"></search-company>
                <search-dataservice class="full" appearance="fill" [company]="selectedCompany" [searchDataserviceForm]="addUserDataServiceForm"></search-dataservice>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-flat-button color="primary" [disabled]="addUserDataServiceForm.invalid" (click)="onAddUserDataService()">Save</button>
        </mat-dialog-actions>
    </form>
}@else{
    <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner class="bright-spinner" mode="indeterminate"></mat-progress-spinner>
    </div>
}
